const state = () => ({
	confirmationItemData: []
});

const mutations = {
	setOrderConfirmationItemData(state, confirmationItemData) {
		state.confirmationItemData = confirmationItemData;
	}
};

export default {
	state,
	mutations
};
